<template>
  <div class="container">
    <vue-headful title="ABL Groupe | Realisations" />
    <h2>Orchard Road trade center, Singapore</h2>
    <section class="realisation--section">
      <div class="realisation--description col-xs-12 col-md-5">
          <div class="col-xs-12">
            <h3>Profils extrudés de structure</h3>
            <div>
              <p>Matière : AISI 316LN</p>
              <p>Architecte : Raimond WOO</p>
            </div>
            
          </div>
        <img class="image--description" :src="require('../../assets/images/orchard.png')" alt="">
        </div>
        <div class="image--container col-xs-12">
          <img :src="require('../../assets/images/orchard1.jpg')"/>
          <img class="flex-end" :src="require('../../assets/images/orchard2.jpg')"/>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ExtrudedStructuralProfiles"
}
</script>

<style lang="scss" scoped>

.realisation--description {
  display: flex;
  .image--description {
    height: 300px;
    width: auto;
    object-fit: cover;
  }
}
.image--container {
  display: flex;
  flex-direction: row;

  .flex-end {
    margin-left: auto;
  }

  img {
    height: 500px;
  }
}

</style>